<template>
  <FormInputText :id="inputId" type="number" step="1" :min="min" :max="max" :notRequired="notRequired" :disabled="disabled" :placeholder="placeholder" v-model.number="internalValue" />
</template>

<script>

import formInputFieldMixin from './mixins/formInputField';
import formInputTextPropsMixin from './mixins/formInputTextProps';

export default {
  name: 'form-form-input-amount',
  mixins: [formInputFieldMixin, formInputTextPropsMixin],
  components: {
    FormInputText: () => import('./FormInputText'),
  },
  computed: {
    internalValue: {
      set (val) {
        this.$emit('input', parseInt(val));
      },
      get () {
        return parseInt(this.value);
      },
    },
  },
};

</script>
